export var source = "query UnsubscribeReasons {\n  unsubscribeReasons(quickFlow: true) {\n    value: name\n    title: reason\n  }\n}";
export default source;